<template>
  <div class="pb-1">
    <v-divider class="pb-1"></v-divider>
    <v-list-item class="px-0" @click="onItemClick">
      <v-list-item-icon class="ma-0 mr-3" v-if="entry.type !== 'Headline'">
        <v-img
          v-if="imageUrl"
          :width="iconProps.width"
          :height="iconProps.height"
          :src="imageUrl"
        />
        <div
          v-else
          align="center"
          class="d-inline-block icon-bg"
          :style="`width: ${iconProps.width}; height: ${iconProps.height}`"
        >
          <v-icon x-large :class="`${iconProps.spacing}`" color="#ffffff80">
            $bildungsportal
          </v-icon>
        </div>
      </v-list-item-icon>
      <v-list-item-content>
        <div>
          <v-chip x-small class="badge">{{ entry.filter }}</v-chip>
        </div>
        <v-list-item-title class="primary--text font-weight-bold">
          {{ entry.Titel }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ entry.Subtitel }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: 'SearchBildungsMaterialRow',
  props: {
    entry: {
      type: Object,
      required: true
    },
    iconProps: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl() {
      const image = this.entry.Vorschau || this.entry.Header;
      if (!image) return null;
      return this.$store.getters.getStrapiImageUrl(image, 'thumbnail');
    }
  },
  methods: {
    onItemClick() {
      this.$store.dispatch('analytics/commitSearchSession', {
        followUpType: 'bildungsportal_material',
        followUp: this.entry
      });

      this.$router.push({
        name: 'bildungsmaterial-details',
        params: { id: this.entry.id }
      });
    }
  }
};
</script>

<style scoped>
.v-list-item:hover {
  cursor: pointer;
  background-color: #9c00471a;
}

.icon-bg {
  background: transparent linear-gradient(226deg, #b40055 0%, #025399 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1;
}
</style>
